export const pushFooterLeftUrls = []
export const pushFooterRightUrls = []
export const noHideFooterUrls = []
export const footerProfileRules = []

export const pushHeaderLeftUrls = []
export const pushHeaderRightUrls = []
export const noHideHeaderUrls = []
export const headerProfileRules = []

export const pushToolbarLeftUrls = []
export const pushToolbarRightUrls = []
export const flipToolbarVerticallyUrls = []
export const noHideToolbarUrls = []
export const backButtonToolbarUrls = []

export const columnConfig = {}
export const contentSafeAreaTopDisabledUrls = []

export const getHeaderElement = () => document.querySelector('[data-layout="header"]')
export const getFooterElement = () => document.querySelector('[data-layout="footer"]')

export const getHeaderHeight = () => getHeaderElement()?.offsetHeight || 0
export const getFooterHeight = () => getFooterElement()?.offsetHeight || 0

const matchesUrl = (url, path) => {
    if (typeof url === 'function') return url(path)
    return path.startsWith(url)
}

const matchesUrls = (urls, path) => {
    const excluded = urls.filter(u => typeof u === 'string' && u.startsWith('!')).map(u => u.slice(1))
    if (excluded.some(u => path.startsWith(u))) return false
    return urls.some(u => !(typeof u === 'string' && u.startsWith('!')) && matchesUrl(u, path))
}

export const getHeaderPosition = (path, {hasLocationFrom = false} = {}) => {
    const position = matchesUrls(pushHeaderRightUrls, path) ? 'right'
        : matchesUrls(pushHeaderLeftUrls, path) ? 'left' : 'center'
    if (position === 'right' && backButtonToolbarUrls.some(url => typeof url === 'function' ? url(path) : path.includes(url)) && !hasLocationFrom) return 'center'
    return position
}

export const getFooterPosition = (path) =>
    matchesUrls(pushFooterRightUrls, path) ? 'right' : matchesUrls(pushFooterLeftUrls, path) ? 'left' : 'center'

export const getToolbarPosition = (path) =>
    matchesUrls(pushToolbarRightUrls, path) ? 'right' : matchesUrls(pushToolbarLeftUrls, path) ? 'left' : 'center'
export const getFlipToolbarVertically = (path) => matchesUrls(flipToolbarVerticallyUrls, path)

export const getNoHideHeader = (path) => matchesUrls(noHideHeaderUrls, path)
export const getNoHideFooter = (path) => matchesUrls(noHideFooterUrls, path)
export const getNoHideToolbar = (path) => matchesUrls(noHideToolbarUrls, path)
export const getContentSafeAreaTopEnabled = path => !matchesUrls(contentSafeAreaTopDisabledUrls, path)
export const getHeaderProfile = (path) => headerProfileRules.some(rule => rule(path))
export const getFooterProfile = (path) => footerProfileRules.some(rule => rule(path))

export const headerContentRules = []
export const getHeaderContent = (pathname) => {
    for (const rule of headerContentRules) {
        const result = rule(pathname)
        if (result !== false) return result
    }
}

export const headerLeftContainerRules = []
export const getHeaderLeftContainerContent = (pathname) => {
    for (const rule of headerLeftContainerRules) {
        const result = rule(pathname)
        if (result !== false) return result
    }
}

export const headerRightContainerRules = []
export const getHeaderRightContainerContent = (pathname) => {
    for (const rule of headerRightContainerRules) {
        const result = rule(pathname)
        if (result !== false) return result
    }
}

export const footerRightContainerRules = []
export const getFooterRightContainerContent = (pathname) => {
    for (const rule of footerRightContainerRules) {
        const result = rule(pathname)
        if (result !== false) return result
    }
}

export const footerContentRules = []
export const getFooterContent = (pathname, {portfolioMode = false} = {}, {isMobile} = {}) => {
    for (const rule of footerContentRules) {
        const result = rule(pathname, {portfolioMode, isMobile})
        if (result !== false) return result
    }
}

export const footerColorRules = []
export const getFooterColor = (pathname) => {
    for (const rule of footerColorRules) {
        const result = rule(pathname)
        if (result !== false) return result
    }
}

export const appFooterHiddenRules = []
export const getAppFooterVisible = (pathname, {isMobile = false} = {}) => {
    for (const rule of appFooterHiddenRules) {
        if (rule(pathname, {isMobile})) return false
    }
    return true
}

export const appLogoHiddenRules = []
export const getAppLogoVisible = (pathname, {isMobile = false} = {}) => {
    for (const rule of appLogoHiddenRules) {
        if (rule(pathname, {isMobile})) return false
    }
    return true
}

export const toolbarContentRules = []
export const getToolbarContent = (pathname, {hasLocationFrom = false} = {}) => {
    for (const rule of toolbarContentRules) {
        const result = rule(pathname, {hasLocationFrom})
        if (result !== false) return result
    }
}
